import React from 'react';
import PropTypes from 'prop-types';

import ClosePopupButton from '../ClosePopupButton';

import './styles.scss';

const PopupHeader = (
  {
    popupId,
    text,
    closeCallBack,
    withClose,
  },
) => (
  <div className='popup-header'>
    {
      text && (
        <h2>{text}</h2>
      )
    }
    {
      withClose && (
        <ClosePopupButton popupId={popupId} closeCallBack={closeCallBack}/>
      )
    }
  </div>
);

PopupHeader.defaultProps = {
  text: '',
  withClose: true,
  closeCallBack: () => {
  },
};

PopupHeader.propTypes = {
  popupId: PropTypes.string.isRequired,
  text: PropTypes.string,
  withClose: PropTypes.bool,
  closeCallBack: PropTypes.func,
};

export default PopupHeader;
